var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      align: "right"
    }
  }, [_c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.batchAudit
    }
  }, [_vm._v("批量审核")])], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "title",
      label: "标题",
      width: "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm.searchForm.type == 1 ? _c("wlc-lifestyle-table-link", {
          attrs: {
            id: scope.row.objId,
            token: scope.row.objId,
            title: scope.row.title
          }
        }) : _vm._e(), _vm.searchForm.type == 2 ? _c("wlc-article-table-link", {
          attrs: {
            id: scope.row.objId,
            token: scope.row.objId,
            title: scope.row.title
          }
        }) : _vm._e(), _vm.searchForm.type == 3 ? _c("wlc-used-table-link", {
          attrs: {
            id: scope.row.objId,
            token: scope.row.objId,
            title: scope.row.title
          }
        }) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.name",
      label: "评论人",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var userInfo = _ref.row.userInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "otherUser.name",
      label: "被评论人",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var otherUserInfo = _ref2.row.otherUserInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: otherUserInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "content",
      label: "评论内容"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "create",
      label: "评论时间",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "100",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.deleteItem(scope.row);
            }
          }
        }, [_vm._v("删除")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };